export { default as Index } from './Index.vue';
export { default as Error } from './Error.vue';
export { default as Reload } from './Reload.vue';
export { default as Contact } from './Contact.vue';
export { default as Registration } from './Registration.vue';
export { default as RegistrationSuccess } from './RegistrationSuccess.vue';
export { default as Blank } from './Blank.vue';
export { default as NotFound } from './404.vue';
export { default as Agb } from './Agb';
export { default as Impressum } from './Impressum';



// WEBPACK FOOTER //
// ./src/pages/index.js